export class LayerControlManager {
    constructor(element, map, layers) {
        this.element = element;
        this.map = map;
    }
    onAdd(map) {
        this.map = map;
        return this.element;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
    onRemove(map) {
    }
}
